/**
 * 사업자 메뉴 관리 API 서비스
 */
import { apiClient } from './client';
import { API_ENDPOINTS } from '../../config/api';

// ─── 타입 정의 ────────────────────────────────────────────────────────────────

export interface AdminBusinessMenu {
  menuSeq: number | null;
  menuName: string;
  modifiedBy?: string;
}

export interface AdminBusinessMenuPermission {
  permissionsSeq: number | null;
  menuSeq: number | null;
  permissionsName: string;
  permissionsValue: string;
  valueType: string;
  modifiedBy?: string;
}

export interface AdminBusinessMenuTargetUrl {
  url: string;
  method: string;
  description: string;
  permissionsSeq: number | null;
  modifiedBy?: string;
}

// ─── API 서비스 ────────────────────────────────────────────────────────────────

export const adminBusinessMenuApi = {
  // ── 메뉴 ──────────────────────────────────────────────────────────────────

  getMenus: async (): Promise<AdminBusinessMenu[]> => {
    const response = await apiClient.get(API_ENDPOINTS.ADMIN_BUSINESS_MENU.MENU_LIST);
    if (response.data?.data) return response.data.data;
    return response.data;
  },

  saveMenu: async (param: AdminBusinessMenu): Promise<void> => {
    await apiClient.post(API_ENDPOINTS.ADMIN_BUSINESS_MENU.MENU_SAVE, param);
  },

  deleteMenu: async (param: AdminBusinessMenu): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.ADMIN_BUSINESS_MENU.MENU_DELETE, { data: param });
  },

  // ── 권한 ──────────────────────────────────────────────────────────────────

  getPermissions: async (menuSeq: number): Promise<AdminBusinessMenuPermission[]> => {
    const response = await apiClient.get(API_ENDPOINTS.ADMIN_BUSINESS_MENU.PERMISSIONS_LIST, {
      params: { menuSeq },
    });
    if (response.data?.data) return response.data.data;
    return response.data;
  },

  savePermissions: async (param: AdminBusinessMenuPermission[]): Promise<void> => {
    await apiClient.post(API_ENDPOINTS.ADMIN_BUSINESS_MENU.PERMISSIONS_SAVE, param);
  },

  deletePermissions: async (param: AdminBusinessMenuPermission[]): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.ADMIN_BUSINESS_MENU.PERMISSIONS_DELETE, { data: param });
  },

  // ── 대상 URL ──────────────────────────────────────────────────────────────

  getTargetUrls: async (permissionsSeq: number): Promise<AdminBusinessMenuTargetUrl[]> => {
    const response = await apiClient.get(API_ENDPOINTS.ADMIN_BUSINESS_MENU.TARGET_URL_LIST, {
      params: { permissionsSeq },
    });
    if (response.data?.data) return response.data.data;
    return response.data;
  },

  saveTargetUrls: async (param: AdminBusinessMenuTargetUrl[]): Promise<void> => {
    await apiClient.post(API_ENDPOINTS.ADMIN_BUSINESS_MENU.TARGET_URL_SAVE, param);
  },

  deleteTargetUrls: async (param: AdminBusinessMenuTargetUrl[]): Promise<void> => {
    await apiClient.delete(API_ENDPOINTS.ADMIN_BUSINESS_MENU.TARGET_URL_DELETE, { data: param });
  },
};
